<template>
	<div>
		<div style="margin-top: 15px;">
			<div style="width: 100%;text-align: right;">
				<el-date-picker
					style="width: 235px;margin-left: 3px;"
					v-model="time"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					format="yyyy-MM-dd">
				</el-date-picker>
				<el-button type="primary" style="margin-left: 3px;" icon="el-icon-search" @click="updateTable">搜索</el-button>
			</div>
		</div>
		<div style="margin-top: 15px;">
			<el-table ref="multipleTable" 
				 :data="tableData" 
				 style="width: 100%" 
				 element-loading-text="数据正在加载中" 
				 @selection-change="handleSelectionChange"
				 :header-cell-style="headClass"
			 	 :row-style="rowClass">
		      <el-table-column type="selection" width="60"></el-table-column>
		      <el-table-column prop="payId" label="支付流水号" sortable></el-table-column>
		      <el-table-column label="奖励">
                  <template slot-scope="scope">
				      		<div>
                                <span>{{moneyFormat(scope.row.money)}}</span>
				      		</div>
				      	</template>
              </el-table-column>
		      <el-table-column prop="remarks" label="新招代理商"></el-table-column>
		      <el-table-column prop="posttime" label="订单完成时间" :formatter="dateFormat"></el-table-column>
		    </el-table>
		    <el-pagination background
	    			style="text-align:right;margin-top: 15px;margin-bottom: 55px;"
		            @size-change="handleSizeChange"
		            @current-change="handleCurrentChange"
		            :current-page="currentPage"
		            :page-sizes="[10, 50, 100, 200]"
		            :page-size="pageSize" 
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="total">
		    </el-pagination>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'companyRevenue',
  components: {
  },
  data() {
    return {
    	total: 0,
        currentPage: 1,
　　  	pageSize: 10,
		tableData:[],
		multipleSelection:[],
		selectValue:"",
		queryValue:"",
		time:[]
    }
  },
  watch: {
  },
  computed:{
  },
  mounted() {
  	this.updateTable();
  },
  beforeDestroy() {
  },
  methods: {
  	handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  	handleSizeChange(val) {
      this.pageSize = val;
      this.updateTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateTable();
    },
    updateTable(){
    	var params = {
    		pageId:this.currentPage,
  			size:this.pageSize
    	}
    	if(this.time != null && this.time.length > 0){
	  		params.startDate = this.getStandardDate(this.time[0]);
	  		params.endDate = this.getStandardDate(this.time[1]);
	  	}
    	const loading = this.$loading({
          lock: true,
          text: '获取表格数据中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 3000);
    	var thiz = this;
  		axios.get(this.$store.getters.getApiValue+'/income/rewardList.do',{
  			params:params
  		}).then(function (response) {
  				loading.close();
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.total = data.totalCount;
		    		thiz.tableData = data.data;
			    }else{
					thiz.$message.error(data.message);
				}
			}).catch(function (error) {
				loading.close();
				thiz.$message.error("系统异常，请与管理员联系!");
			    console.log(error);
			});
    },
    dateFormat(row,column){
		var str = row[column.property];
		if(str == null || str == ""){
			return "";
		}else{
			return this.getStandardDate(new Date(str));
		}
	},
	getStandardDate(val){
    	var year = val.getFullYear();
        var month = val.getMonth() + 1;
        var day = val.getDate();
        month = month < 10 ? "0"+month : month;
        day = day < 10 ? "0"+day : day;
        return year+"-"+month+"-"+day;
   	},
    headClass({ row, rowIndex}) {
    	if(rowIndex == 0){
    		return ''
    	}
	    return ''
	},
    rowClass({ row, rowIndex}) {
	    if(rowIndex%2 == 0){
	    	return 'background:#F1F2F7;'
	    }else{
	    	return 'background:white;'
	    }
	    return ''
	},
	getMessage(row){
		alert(row.remarks);
    },
    moneyFormat(val){
        val = val.toString().replace(/[^\d.]/g,""); //清除"数字"和"."以外的字符
        let val1 = parseFloat(val).toFixed(2);  //保留两位小数
        let val2 = val1.toString();
        let arr = val2.split('.');
        let arr1 = arr[0].split('');
        let str3 = "";
        let arr2 = [];
        for(let i=arr1.length-1,j=0;i>=0;i--,j++) {
          str3 = '' + arr1[i] + str3;
          if(j%3==2) {
            arr2.unshift(str3)
            str3 = "";
          }else if(i==0) {
            arr2.unshift(str3)
          }
        }
        let str4 = arr2.join(',');
        let str5 = str4 + '.' + arr[1];
        return str5;
    }
  }
}
</script>

<style>
  .el-table{
  	font-size: 12px;
  	border-bottom: 1px solid #dcd8d8;
  	color: black;
  }
  .el-table tr th{
  	border-top: 0px;
  	border-left: 0px;
  	border-right: 0px;
  }
  .el-table tr td{
  	border-bottom: 1px solid #dcd8d8;
  }
</style>